// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3P9N4","inner":"footer_inner__UpPWR","footer-menu":"footer_footer-menu__2ncdc"};